<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 顶部栏 -->
      <div class="topbar">
        <el-input
          v-model="searchValue"
          size="small"
          placeholder=""
          prefix-icon="el-icon-search"
        />
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click.stop="addEvent()"
        >
          添加新活动
        </el-button>
      </div>

      <!-- 内容 -->
      <el-table
        :data="activityList"
        :header-cell-style="{ background: '#F5F7FA' }"
        style="width: 100%; margin-bottom: 20px"
      >
        <el-table-column
          prop="ActivityID"
          label="活动编号"
          align="center"
          width="100"
        />
        <el-table-column
          prop="ActivityTitle"
          label="标题"
          align="center"
          show-overflow-tooltip
        />
        <el-table-column
          prop="ActivityProfile"
          label="描述"
          align="center"
          show-overflow-tooltip
        />
        <el-table-column label="活动类别" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.ActivityType | activityTypeTransform }}
          </template>
        </el-table-column>
        <el-table-column label="封面" align="center">
          <template slot-scope="scope">
            <el-image
              fit="scale-down"
              style="max-height: 100px; max-width: 100px"
              :src="`${config.RESOURCES + scope.row.Image}`"
              lazy
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column label="奖项" align="center" prop="PrizeList">
          <template slot-scope="scope">
            <div v-for="item in scope.row.PrizeList" :key="LuckyDrawID">
              {{ item.PrizeName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="开始时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.StartTime | formatDateTime }}
          </template>
        </el-table-column>
        <el-table-column label="结束时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.EndTime | formatDateTime }}
          </template>
        </el-table-column>
        <el-table-column label="活动状态" align="center">
          <template slot-scope="scope">
            <el-tag size="medium" :type="formatTagType(scope.row)">
              {{ formatTagLabel(scope.row) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          header-align="center"
          align="right"
          width="400"
        >
          <template slot-scope="scope">
            <el-button
              v-show="scope.row.ActivityType === 3"
              size="small"
              type="primary"
              icon="el-icon-data-analysis"
              title="投票"
              @click.stop="goToVotePage(scope.row)"
            />
            <el-button
              size="small"
              type="primary"
              icon="el-icon-orange"
              title="抽奖"
              @click.stop="goToLotteryPage(scope.row)"
            />
            <el-button
              size="small"
              type="primary"
              icon="el-icon-share"
              title="分享活动地址"
              @click.stop="shareUrl(scope.row)"
            />
            <el-button
              size="small"
              type="primary"
              icon="el-icon-present"
              title="查看活动奖项"
              @click.stop="viewAwards(scope.row)"
            />
            <el-button
              size="small"
              type="primary"
              icon="el-icon-user"
              title="查看参与用户"
              @click.stop="goToEventDetail(scope.row, '1')"
            />
            <el-button
              size="small"
              type="primary"
              icon="el-icon-edit"
              title="编辑活动"
              @click.stop="goToEventDetail(scope.row, '0')"
            />
            <el-button
              size="small"
              type="danger"
              icon="el-icon-delete"
              title="删除活动"
              @click.stop="deleteActivity(scope.row)"
            />
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        v-show="totalCount > pageSize"
        background
        layout="prev, pager, next"
        :total="totalCount"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="currentChange"
      />
    </el-card>

    <el-dialog title="奖项列表" :visible.sync="awardsListDialog" width="20%">
      <el-table :data="awardsList" style="width: 100%">
        <el-table-column prop="PrizeGrade" label="奖项等级" align="center" />
        <el-table-column prop="PrizeName" label="奖项名称" align="center" />
      </el-table>
    </el-dialog>

    <el-dialog
      title="参与二维码"
      :visible.sync="qrcodeDialog"
      width="10%"
      destroy-on-close
    >
      <div id="qrcode" ref="qrcode" class="zoom"></div>
    </el-dialog>

    <!-- addEventDialog -->
    <el-dialog title="新增抽奖" :visible.sync="addEventDialog" width="30%">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="发布区域">
          <el-select v-model="form.region" style="width: 100%">
            <el-option label="区域一" value="shanghai" />
            <el-option label="区域二" value="beijing" />
          </el-select>
        </el-form-item>
        <el-form-item label="活动标题">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="活动描述">
          <el-input v-model="form.name" type="textarea" />
        </el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker
            v-model="form.datetime"
            type="datetime"
            placeholder="选择日期时间"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="form.datetime"
            type="datetime"
            placeholder="选择日期时间"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="上传封面">
          <!-- <el-upload
            class="upload-demo"
            action="https://jsonplaceholder.typicode.com/posts/"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :file-list="fileList"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload> -->
        </el-form-item>
        <el-form-item label="活动背景">
          <el-radio-group v-model="form.resource">
            <el-radio label="默认" />
            <el-radio label="自定义" />
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addEventDialog = false">
          取 消
        </el-button>
        <el-button type="primary" size="small" @click="addEventDialog = false">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import {
  getActivityList,
  addActivity,
  deleteActivity,
} from "@/api/eventSquare";

export default {
  data() {
    return {
      activeIndex: "0", // 当前索引
      loading: false, // 加载开关
      searchValue: "", // 搜索内容
      totalCount: 0, // 列表总数
      pageSize: 10, // 单页条数
      currentPage: 1, // 当前页码
      addEventDialog: false,
      activityList: [],
      form: {
        name: "",
      },
      awardsList: [],
      awardsListDialog: false,
      qrcodeDialog: false,
      qrcode: null,
    };
  },
  computed: {
    formatTagType() {
      return function (row) {
        // 当前时间
        const currentTime = new Date();
        const endTime = new Date(row.EndTime);
        if (currentTime >= endTime) {
          return "info";
        } else {
          return "primary";
        }
      };
    },
    formatTagLabel() {
      return function (row) {
        // 当前时间
        const currentTime = new Date();
        const endTime = new Date(row.EndTime);
        if (currentTime >= endTime) {
          return "已结束";
        } else {
          return "进行中";
        }
      };
    },
  },
  created() {
    this.getActivityList();
  },
  methods: {
    /**
     * 翻页
     *
     * @param {number} currentPage 当前页码
     */
    currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getActivityList();
    },
    /**
     * 获取所有活动列表
     */
    getActivityList() {
      const params = {
        sortName: "",
        sortOrder: "",
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        keyword: this.searchValue,
        where: "",
      };

      getActivityList(params).then((res) => {
        this.activityList = res.Rows;
        this.totalCount = res.Total;
        console.log(res.Rows[1]);
      });
    },
    /**
     *
     */
    addEvent() {},
    /**
     *
     */
    openAddActivityDialog() {
      this.addEventDialog = true;
    },
    /**
     * 添加活动
     */
    addActivity() {
      const data = {};
      addActivity(data).then((res) => {
        console.log(res);
      });
    },
    /**
     * 打开抽奖页面
     *
     * @param {object} row 所选对象信息
     */
    goToVotePage(row) {
      window.open(row.URL, "_blank");
    },
    /**
     * 打开抽奖页面
     *
     * @param {object} row 所选对象信息
     */
    goToLotteryPage(row) {
      window.open(row.LuckyDrawPageURL, "_blank");
    },
    /**
     * 分享二维码
     *
     * @param {object} row 所选对象信息
     */
    shareUrl(row) {
      this.qrcodeDialog = true;
      this.$nextTick(() => {
        this.newQrcode(row);
      });
    },
    /**
     * 生成二维码
     *
     * @param {object} row 所选对象信息
     */
    newQrcode(row) {
      this.qrcode = new QRCode("qrcode", {
        width: 150, // 设置宽度，单位像素
        height: 150, // 设置高度，单位像素
        text: row.ScanCodeCheckInPageUrl, // 设置二维码内容或跳转地址
      });
    },
    /**
     * 查看奖项
     *
     * @param {object} row 所选对象信息
     */
    viewAwards(row) {
      this.awardsList = row.PrizeList;
      this.awardsListDialog = true;
    },
    /**
     * 跳转到活动详情
     *
     * @param {object} row 所选对象信息
     * @param {number} activeIndex 当前激活tab
     */
    goToEventDetail(row, activeIndex) {
      this.$router.push({
        path: "eventDetail",
        query: {
          activityID: row.ActivityID,
          activeIndex: activeIndex,
        },
      });
    },
    /**
     * 删除活动
     *
     * @param {object} row 所选对象信息
     */
    deleteActivity(row) {
      console.log(row);
      this.$confirm("是否删除该活动", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          const params = {};
          deleteActivity(params).then((res) => {
            console.log(res);
            this.$message({
              type: "success",
              message: "删除成功",
            });
          });
        })
        .catch(() => {
          this.$message("取消操作");
        });
    },
  },
};
</script>

<style scoped lang="scss"></style>
